<pr-form
  (onSubmit)="onSubmit()"
  [title]="title"
  [formGroup]="form"
  clazz="drawer-form"
  [formWithTabs]="true"
  (nextTab)="nextTab()"
  [tabChanged]="tabChanged"
>
  @if (entity.id) {
    <pr-button-confirm
      top-right-action
      display="danger"
      icon="delete_outline"
      (onConfirm)="
        googleAnalyticsService.event('scpi', 'immobilier', 'delete scpi');
        doneSubject.next();
        postDeleteMessage(entity)
      "
      comment="Toute suppression est definitive, les données seront perdues."
      labelConfirm="Supprimer"
      labelCancel="Annuler"
    >
      Êtes-vous sûr(e) de vouloir supprimer <em>“{{ entity.label }}”</em>
    </pr-button-confirm>
  }

  <input formControlName="id" type="hidden" />
  <pr-tabs
    clazz="drawer-tab-button"
    [defaultTextColor]="false"
    [changeTab]="changeTab"
    (lastTab)="onTabChange($event)"
  >
    <pr-tab label="Informations générales">
      <h3 class="drawer-title">Informations du bien</h3>
      <div class="form-sct-container">
        <pr-input-autosuggest
          formControlName="product"
          label="Nom de la SCPI"
          [options]="scpis"
          [derrors]="derrors"
          [optionLabel]="'name'"
          [noCustom]="true"
        >
        </pr-input-autosuggest>

        <pr-input-date
          formControlName="startDate"
          label="Date de début"
          [derrors]="derrors"
        ></pr-input-date>

        <pr-input label="Type de détention" [derrors]="derrors">
          <mat-select formControlName="ownershipType">
            @for (item of realEstateOwnershipTypes; track item) {
              <mat-option [value]="item.id">
                {{ item.value | translate }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input
          label="Durée du démembrement"
          [derrors]="derrors"
          [hidden]="form.get('ownershipType').value == 'PLEINE_PROPRIETE'"
        >
          <mat-select formControlName="dismemberDuration">
            @for (i of _.range(1, 21); track i) {
              <mat-option [value]="i">
                {{ i + ' an' + (i > 1 ? 's' : '') }}</mat-option
              >
            }
          </mat-select>
        </pr-input>

        <pr-input
          [label]="'Clef de démembrement'"
          [suffix]="'%'"
          [derrors]="derrors"
          [suggestion]="suggestedDismemberKey"
          (suggestionClicked)="
            patch({ dismemberKey: suggestedDismemberKey.toFixed() })
          "
          [hidden]="form.get('ownershipType').value == 'PLEINE_PROPRIETE'"
        >
          <input
            formControlName="dismemberKey"
            type="text"
            (focus)="processDismembermentKey()"
          />
          <span suggestion
            >Suggestion :
            {{
              suggestedDismemberKey ? suggestedDismemberKey.toFixed() : ''
            }}%</span
          >
        </pr-input>

        <pr-input
          [label]="'Montant investi'"
          [loading]="loading"
          [suffix]="'€'"
          [derrors]="derrors"
        >
          <input formControlName="purchasePrice" type="text" />
          <!-- <button suggestionButton type="button">button 1</button>
              <button suggestionButton type="button">button 2</button> -->
        </pr-input>

        <pr-input
          [label]="'Nombre de parts'"
          [loading]="loading"
          [suffix]="'part(s)'"
          [derrors]="derrors"
          ><input formControlName="nbShare" type="text"
        /></pr-input>
      </div>
      <h3 class="drawer-title">Informations du crédit</h3>
      <div class="form-sct-container">
        <ea-estate-loan-form
          [entity]="entity"
          [derrors]="derrors"
        ></ea-estate-loan-form>
      </div>
    </pr-tab>
    <pr-tab label="Détention">
      <h3 class="drawer-title">Informations sur la détention</h3>
      <div class="form-sct-container">
        <pr-input label="Acquis au travers de" [derrors]="derrors">
          <mat-select formControlName="subscriptionSource">
            @for (item of subscriptionSource; track item) {
              <mat-option [value]="item.id">
                {{ item.value | translate }}
              </mat-option>
            }
          </mat-select>
        </pr-input>

        <pr-input-owner-share
          formControlName="owners"
          [derrors]="derrors"
        ></pr-input-owner-share>
      </div>
    </pr-tab>
  </pr-tabs>
</pr-form>
